import React from "react";
import { t } from "../../../../utils/i18n";

const WidgetFooter = () => {
  return (
    <div className="doc-footer">
      <p>{t("store_integrations.widget.need_assistance")}</p>
      <a
        href="https://www.bananacrystal.com/contact-us/"
        target="_blank"
        rel="noopener noreferrer"
        className="contact-support-link"
      >
        {t("store_integrations.widget.contact_support")}
      </a>
    </div>
  );
};

export default WidgetFooter;
